(function (SocialProof, $) {
  'use strict';

  let $slider;
  let $logoLinks;

  const cacheDom = () => {
    $slider = $('.social-proof-sliderr');
    $logoLinks = $('.social-proof-logo');
  }

  const bindUIActions = () => {
    $slider.on('initialized.owl.carousel', function () {
      $($logoLinks[0]).addClass('active');
    });

    $slider.on('changed.owl.carousel', function (event) {
      const index = event.page.index;
      $logoLinks.removeClass('active');
      $($logoLinks[index]).addClass('active');
    });

  }

  const init = () => {
    cacheDom();
    bindUIActions();
  }

  SocialProof.init = init;

})(window.SocialProof = window.SocialProof || {}, jQuery);
